export default __webpack_public_path__ + "static/media/product-solid.6c69bbb6.svg";